import {
  getLoomVideoEmbedUrlFromShareUrl,
  isLoomVideoUrl,
  isVimeoVideoLink,
} from "features/Common/modules/Urls&Routing/Urls&Routing.utils";
import React from "react";
import ReactPlayer from "react-player/lazy";
import { getGoogleDriveDownloadableUrl } from "utils/fileUtils";
import { getPrivateS3Bucket } from "utils/recordedContentUtils/recordedContentUtils";
import { isGoogleDriveFile, isYoutubeVideoLink } from "utils/validations";
import { Video } from "../PrivateVideo/PrivateVideo";
import VideoComp from "../VideoComp";
import moduleStyles from "./ContentRow.module.css";

const I_FRAME_WIDTH = "640";
const I_FRAME_HEIGHT = "390";

const BasicVideoPlayer = ({ url, isZoomRecording, originListing }) => {
  // if DRM expired for the creator then showing unwatermarked video
  // the url must me signed in order to play video
  const isUnwatermarkedUrl = getPrivateS3Bucket(url);

  if (isUnwatermarkedUrl) return <Video url={url} width="100%" />;

  const isLoomLink = isLoomVideoUrl(url);
  const isVimeoLink = isVimeoVideoLink(url);
  const isYouTubeLink = isYoutubeVideoLink(url);
  const isGoogleDriveLink = isGoogleDriveFile(url);
  const renderReactPlayer = isVimeoLink || isYouTubeLink || isGoogleDriveLink;

  if (isLoomLink)
    return (
      <iframe
        title="loom-iframe"
        src={getLoomVideoEmbedUrlFromShareUrl(url)}
        width={I_FRAME_WIDTH}
        height={I_FRAME_HEIGHT}
        className={moduleStyles.videoIframe}
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
      />
    );

  if (isGoogleDriveLink)
    return (
      <iframe
        title="google-drive-iframe"
        src={url}
        width={I_FRAME_WIDTH}
        height={I_FRAME_HEIGHT}
        className={moduleStyles.videoIframe}
      />
    );

  if (renderReactPlayer) {
    return (
      <ReactPlayer
        controls
        url={isGoogleDriveLink ? getGoogleDriveDownloadableUrl(url) : url} // for google drive video link, need to get a downloadable link to embed it in iframe
        width={I_FRAME_WIDTH}
        height={I_FRAME_HEIGHT}
        className={moduleStyles.videoIframe}
      />
    );
  }

  return (
    <VideoComp
      isZoomRecording={isZoomRecording}
      url={url}
      originListing={originListing}
    />
  );
};

export default BasicVideoPlayer;
